<template>
  <div
    class="col full-height q-pb-sm attendance-transfer"
    :style="'max-width: 240px'"
  >
    <div class="row height-30px q-mb-xs q-mt-sm">
      <div class="col q-px-sm">
        <div class="row full-height content-center">
          <SearchIcon class="search-icon q-ma-sm absolute" />

          <input
            type="text"
            class="fit input-search font-search"
            v-model="filter"
            placeholder="Buscar agente..."
          >
        </div>
      </div>
    </div>

    <div
      class="row height-30px q-ml-xs"
      v-if="isPreference"
    >
      <q-checkbox
        class="text-caption"
        size="xs"
        label="Transferir preferência"
        v-model="changeOwner"
      />
    </div>

    <div
      v-if="loading"
      class="row full-width height-30px q-mb-xs q-mt-sm"
    >
      <div class="col full-height row items-center justify-center">
        <q-spinner-dots
          size="20px"
          color="primary"
        />
      </div>
    </div>

    <div
      dense
      class="rounded-borders full-width q-px-xs"
    >
      <template v-for="item in items">
        <div
          :class="`row items-center item-slice reverse ${canTransfer(item) ? 'cursor-pointer' : 'cursor-block'}`"
          :key="`transfer-${item.id}`"
          @click="handleClick(item)"
        >
          <div class="col q-px-sm">
            <q-item-label
              class="ellipsis"
              :disabled="!canTransfer(item)"
            >
              <span :class="`${ canTransfer(item) ? 'text-green-8' : 'text-red-8' }`">
                {{ item.description }}
                <span
                  :class="`${ canTransfer(item) ? '' : 'text-red-8' }`"
                  style="font-size: 80%;"
                >({{ item.number }})</span>
              </span>
            </q-item-label>
          </div>

          <q-tooltip
            :content-class="`${canTransfer(item) ? 'bg-green-8' : 'bg-red-8'}`"
            content-style="font-size: 12px"
          >
            <span>{{ canTransfer(item) ? 'Transferir para' : 'Não é possível transferir para' }}</span>
            <span class="text-bold">
              {{ item.description }}
              <span style="font-size: 80%;">({{ item.number }})</span>
            </span>
          </q-tooltip>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import SearchIcon from '@/assets/icons/search.svg'
import getEntryNumbers from '@/libs/getEntryNumbers'

const canTransfer = (item) => {
  const agentStatus = item.status || ''
  const extensionStatus = item.extension?.status || ''

  if (['OFFLINE', 'PAUSED'].includes(agentStatus)) return false
  if (['Unreachable', 'Unknown'].includes(extensionStatus)) return false

  if ((!agentStatus && !extensionStatus) && (item.agentId || item.extensionId)) return false

  return true
}

export default {
  components: {
    SearchIcon
  },

  data () {
    return {
      filter: '',
      showFilter: '',
      agents: [],
      changeOwner: false,
      loading: false,
      isPreference: false
    }
  },

  props: {
    chatId: {},
    agentId: {},
    queueId: {},
    direction: {},
    destination: {}
  },

  async mounted () {
    const vm = this
    vm.elMounted = true
    vm.loading = true

    if (vm.destination) vm.filter = vm.destination

    await this.$store.dispatch('agentModule/getQueuesProperties', this.queueId)

    const queueProperties = vm.$store.state.agentModule.queuesProperties[vm.queueId] || {}
    vm.isPreference = Boolean(queueProperties.attendanceExclusive === 'preference' && vm.direction === 'IN')

    getEntryNumbers(true).catch(() => ({})).then((entryNumbers) => {
      if (!vm.elMounted) return
      vm.agents = entryNumbers.filter(item => item.destinationType === 'AGENTCODE' && item?.status !== 'OFFLINE' && Number(item.agentId) !== Number(vm.agentId))
      if (!vm.agents.length) vm.$emit('close-transfer-options')
      vm.loading = false
    })
  },

  beforeDestroy () {
    const vm = this
    vm.elMounted = false
  },

  computed: {
    ...mapGetters({
      isAdmin: 'settingsModule/isAdmin'
    }),

    ...mapState({
      listAgents () {
        return this.agents.sort((a, b) => Number(canTransfer(b)) - Number(canTransfer(a)))
      }
    }),

    items () {
      const vm = this
      const clearStr = (str) => String(str || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim()
      const arg = clearStr(vm.filter)

      if (arg.length > 7) return 0

      let items = vm.listAgents.filter((item) => {
        const number = clearStr(item.number)
        const description = clearStr(item.description)
        return number.includes(arg) || description.includes(arg)
      })

      if (!items.length) {
        items = vm.agents.filter((item) => {
          const number = clearStr(item.number)
          const description = clearStr(item.description)
          return arg.includes(number) || arg.includes(description)
        })
      }

      return items
    }
  },

  methods: {
    ...mapActions({
      sendTransfer: 'socketModule/sendTransfer'
    }),

    canTransfer,

    transfer (item) {
      const values = {
        destination: item.agentId,
        chatId: this.chatId,
        changeOwner: this.changeOwner
      }
      this.sendTransfer(values)
    },

    handleClick (item) {
      if (this.canTransfer(item)) this.transfer(item)
      this.$emit('hide-menu')
    }

  }
}

</script>

<style lang="sass" scoped>
  .cursor-block
    cursor: not-allowed !important

  .item-slice
    border-bottom: 1px solid #ddd
    padding: 5px 0 5px
    margin-bottom: 5px

  .attendance-transfer
    .input-search
      border: none
      border: 1px solid #CFD8DC
      border-radius: 3px
      padding-left: 28px
      color: #263238
      &:focus
        border: 1px solid #065AA1
        outline: none
      &:hover
        border: 1px solid #cacaca
      &::-webkit-input-placeholder
        color: #263238
        opacity: 0.5
        font-style: normal
        font-weight: normal
        font-size: 12px
        line-height: 12px

    .search-icon
      height: 16px
      width: 16px

    .search-icon > stroke
      fill: #26323866

    .height-30px
      height: 30px
      min-height: 30px
</style>
